"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@material-ui/core");

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var helpers_1 = require("../helpers");

require("./BB8TextSearch.scss");

var BB8TextSearch =
/** @class */
function (_super) {
  __extends(BB8TextSearch, _super);

  function BB8TextSearch() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isDirty: false,
      isTouched: _this.props.initialText !== undefined || false,
      isValid: true,
      text: ""
    };

    _this.handleChange = function (event) {
      _this.update(event.target.value);
    };

    _this.handleBlur = function (event) {
      _this.update(event.target.value);
    };

    _this.update = function (text) {
      _this.setState(function () {
        // const t = text || currentState.text;
        return {
          isDirty: !helpers_1.isEmpty(text),
          isTouched: true,
          isValid: _this.checkIfValid(text),
          text: text
        };
      });
    };

    _this.triggerSearch = function (event) {
      if (event) {
        event.preventDefault();

        if (_this.state.isValid) {
          _this.props.onSearch(_this.state.text);
        }
      }
    };

    _this.checkIfValid = function (str) {
      if (str === undefined) {
        return true;
      }

      var validators = _this.props.validators;

      if (helpers_1.isEmpty(str) || !validators) {
        return true;
      }

      return _this.state.isTouched && validators.every(function (v) {
        return v(str);
      });
    };

    return _this;
  }

  BB8TextSearch.prototype.render = function () {
    var _a = this.props,
        placeholder = _a.placeholder,
        initialText = _a.initialText;
    var _b = this.state,
        isDirty = _b.isDirty,
        isValid = _b.isValid;
    var classes = classnames_1.default("bb8-search", {
      dirty: isDirty,
      invalid: !isValid,
      valid: isValid
    });
    return react_1.default.createElement("form", {
      className: "bb8-search-wrapper",
      onSubmit: this.triggerSearch
    }, react_1.default.createElement("input", {
      type: "text",
      name: "search",
      className: classes,
      placeholder: placeholder,
      onChange: this.handleChange,
      defaultValue: initialText,
      value: this.state.text,
      onBlur: this.handleBlur
    }), react_1.default.createElement(core_1.IconButton, {
      className: "bb8-search-icon",
      disabled: !isValid,
      onClick: this.triggerSearch
    }, react_1.default.createElement(core_1.SvgIcon, null, react_1.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, react_1.default.createElement("path", {
      fill: "#6B6B6B",
      d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }), react_1.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })))));
  };

  return BB8TextSearch;
}(react_1.default.Component);

exports.BB8TextSearch = BB8TextSearch;
exports.default = BB8TextSearch;